module.exports = __webpack_public_path__ + "media/images/emblems/Seegraeben-blazon-12e3a473f0f54dd75f9c454e8d0b88d4.svg";